import PublicOvertimeDetailContainer from './PublicOvertimeDetailContainer';

export default PublicOvertimeDetailContainer;
